<template>
    <v-card>
        <v-toolbar dark class="cyan darken-3" v-if="showHeader">
            <v-toolbar-title>Avaliações</v-toolbar-title>
        </v-toolbar>    
        <v-card-text v-if="showHeader">
            A avaliação dos examinadores está visível <strong>apenas</strong> para o presidente da banca, examinadores, coordenação de curso e coordenação de estágio/TCC.
            Aos examinadores é disponibilizada para consulta apenas a sua própria avaliação.
        </v-card-text>        
        <v-card-title class="pa-1" v-if="errors == false">
            <v-spacer></v-spacer>
            <v-btn fab dark small color="info" @click="loadEvaluations">
                <v-icon dark>refresh</v-icon>
            </v-btn>
        </v-card-title>        
        <v-data-table 
            :headers="headers"
            :items="items"
            :pagination.sync="pagination"
            :loading="loading"
            :no-data-text="noData"
            :no-results-text="noResult"
            :rows-per-page-text="rowsPerPageT"
            hide-actions
            class="elevation-1"
            v-if="errors == false">
            <template slot="items" slot-scope="props">
                <tr :class="getExaminerRowClass(props.item)">
                    <td>{{ getExaminerName(props.item.examiner) }}</td>
                    <td>{{ props.item.status }}</td>
                    <td>{{ props.item.finalScore }}</td>
                    <td align="center">
                        <router-link :to="{ name: 'examEvaluationDetail', params: { id: examId, evaluator: props.item.examiner.id } }">
                            <v-btn color="info" floating small dark fab title="Ver ficha de avaliação">
                                <v-icon dark>description</v-icon>
                            </v-btn>
                        </router-link>                   
                    </td>                    
                </tr>
                <tr :class="getExaminerRowClass(props.item)">
                    <td colspan="4" v-if="props.item.notes">
                        <strong>Comentários:</strong> {{ props.item.notes }} 
                    </td>
                </tr>                
            </template>
        </v-data-table>

        <div class="totalScore" v-if="false">
            <span>Média Sugerida: {{totalScore}}</span>
        </div>
        
        <v-card-title v-if="interval != null">
            <v-alert color="info" value="true">
                Atualizando automaticamente a cada {{ refreshInterval }} segundos.
            </v-alert>
        </v-card-title>        
        <v-card-title v-if="errors != false">
            <v-alert color="error" value="true" v-for="(error, idx) in errors" :key="'error_'+idx">
                {{ error }}
            </v-alert>
        </v-card-title>
        <v-card-actions v-if="showActions">
            <slot name="actions"></slot>
        </v-card-actions>
    </v-card>    
</template>

<script>
    import { noData, noResult, rowsPerPageT } from './../locale/vuetify';

    export default {
        name: 'ExamEvaluation',
        props: {
            examId: {
                type: [Number, String],
                default: ''
            },
            showHeader: {
                type: [Boolean],
                default: true
            },
            refreshInterval: {
                type: [Boolean, Number],
                default: false
            }
        },
        data() {
            return {
                headers: [
                    { text: 'Examinador', align: 'left', value: 'examiner' },
                    { text: 'Situação', align: 'left', value: 'status' },
                    { text: 'Nota final', align: 'left', value: 'finalScore' },
                    { text: 'Ações', align: 'center', value: 'actions' }
                ],
                items: [],
                pagination: {
                    rowsPerPage: 100,
                    sortBy: false,
                    descending: false
                },
                loading: false,
                noData: noData,
                noResult: noResult,
                rowsPerPageT: rowsPerPageT,                
                evaluations: {},
                showActions: false,
                errors: false,
                interval: null,
                evaluationIsOngoing: false,
                totalScore: ''
            }
        },
        methods: {
            init: function () {        
                clearInterval(this.interval)         
                this.interval = null
                this.loadEvaluations()                
            },
            loadEvaluations: function () {                   
                this.loading = true
                this.items = []
                this.evaluation = {}
                this.errors = false
                this.evaluationIsOngoing = false
                this.$http.post('evaluations', { exam: this.examId, hideFullscreenLoadingSpinner: this.interval != null }).then(response => {
                    if (typeof response.data.status !== 'undefined' && response.data.status == 'ok') {
                        this.evaluations = response.data.evaluations
                        this.updateItems()
                        this.loading = false
                    } else {
                        console.log('Erro ao carregar avaliações da banca ' + this.examId)
                    }
                }, response => {
                    if (typeof response.data.errors !== 'undefined') {
                        this.errors = response.data.errors
                    }
                    console.log('Erro ao carregar avaliações da banca ' + this.examId)
                })
            },            
            updateItems: function () {
                this.items = []       

                for (let examiner in this.evaluations) {
                    let evaluation = this.evaluations[examiner], 
                        status = 'Pendente',
                        finalScore = null,
                        notes = null

                    if (evaluation.start != null) {
                        status = 'Em andamento'
                    }
                    if (evaluation.finish != null) {
                        status = 'Finalizada'
                        finalScore = evaluation.final_score
                        notes = evaluation.notes
                    } else {
                        this.evaluationIsOngoing = true
                    }

                    this.items.push({
                        examiner: evaluation.examiner,
                        status: status,
                        finalScore: finalScore,
                        notes: notes
                    })
                }     
                if (this.interval == null) {
                    if (!!this.refreshInterval && this.evaluationIsOngoing) {
                        let seconds = this.refreshInterval * 1000
                        this.interval = setInterval(function() {
                            this.loadEvaluations()
                        }.bind(this), seconds)  
                    }                      
                }

                // Retorna a soma das notas
                let notasVal = this.items.reduce(function (val, e) {
                    return (Number.isNaN(parseFloat(e.finalScore))) ? val : val + parseFloat(e.finalScore)
                }, 0);

                // Retorna a quantidade de notas
                let notasQtd = this.items.filter(function (e) {
                    return e.finalScore !== null;
                }); 

                // Retorna a média
                let auxValor = (notasVal / notasQtd.length);
                if (!Number.isNaN(auxValor)) {
                    this.totalScore = auxValor.toFixed(2).replace('.', ',')

                    this.$emit("updateNotaMedia", this.totalScore);
                }
            },
            getExaminerName: function (examiner) {
                let name = examiner.name
                if (examiner.role == 'substitute') name = name + ' (Suplente)'
                return name
            },
            getExaminerRowClass: function (examiner) {
                if (examiner.status == 'Finalizada')    return 'green lighten-4'
                if (examiner.status == 'Em andamento')  return 'blue lighten-4'
                return ''
            }
        },
        watch: {
            examId: function (newValue) {
                this.init()
            }
        },
        created: function () {
            this.showActions = typeof this.$slots['actions'] !== 'undefined'            
            this.init()     
        },
        beforeDestroy: function() {
            clearInterval(this.interval)
        }        
    }

</script>

<style>
.totalScore {
    padding: 5px;
    margin: 5px;
    text-align: center
}
.totalScore>span{
    font-weight: bold;
    color: #004a9c;
}
</style>


// WEBPACK FOOTER //
// ExamEvaluations.vue?e77db482